import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "../../utils/ui-components.js";

@customElement("api-docs-auth")
export class ApiDocsAuth extends BaseElement {
    @property({ type: String }) apiKey = "YOUR_API_KEY";

    connectedCallback() {
        super.connectedCallback();
        this.style.display = "block";
    }

    render() {
        return html`
            <section class="space-y-4">
                <h2 class="text-2xl font-bold">Authentication</h2>
                <p>
                    All API requests require a valid API key sent as a Bearer token in the
                    <code class="badge badge-ghost">Authorization</code> header.
                </p>

                <api-docs-code-block .code=${`Authorization: Bearer ${this.apiKey}`}></api-docs-code-block>

                <h3 class="text-lg font-semibold">Managing API Keys</h3>
                <ul class="list-disc list-inside space-y-1 text-base-content/80">
                    <li>Create and delete keys on the <a href="/settings" class="link link-primary">Settings</a> page.</li>
                    <li>You can have up to <strong>2 keys</strong> at a time.</li>
                    <li>Keys are shown only once at creation — store them securely.</li>
                    <li>Deleted keys stop working immediately and cannot be recovered.</li>
                </ul>

                <div class="alert alert-warning">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                    <span>Never share API keys in public repos, client-side code, or URLs. Treat them like passwords.</span>
                </div>

                <h3 class="text-lg font-semibold">Authentication Errors</h3>
                <p>
                    If the key is missing or invalid, the API returns <code class="badge badge-ghost">401 Unauthorized</code>. If your subscription is
                    inactive, you'll receive <code class="badge badge-ghost">402 Payment Required</code>.
                </p>
            </section>
        `;
    }
}
